import { Dialog, Button } from '@workspace/design-system/src/components';
import { getPlanLabel } from '../constants';
import { formatDateTime } from '@src/utils/time';
interface PaymentRequestTossSuccessDialogProps {
    channelName: string;
    planType: string;
    expiryDate: string;
    onClose: () => void;
    mode: 'apply' | 'extend';
}

export function PaymentRequestTossSuccessDialog({
    channelName,
    planType,
    expiryDate,
    onClose,
    mode
}: PaymentRequestTossSuccessDialogProps) {
    return (
        <Dialog>
            <Dialog.Content className="max-w-[480px]">
                <Dialog.Header
                    title="결제 링크가 생성되었습니다"
                    type="confirm"
                    showIcon
                />

                <Dialog.Body>
                    <div className="flex flex-col gap-3">
                        <p className="text-[14px] text-[#101010] leading-[20px] tracking-[-0.1px]">
                            결제 링크를 통해 고객이 결제를 완료하면 '{channelName}' 채널에 {getPlanLabel(planType)} 요금제가 {mode == 'apply' ? '적용' : '연장'}됩니다.
                        </p>
                        <span className="text-sm font-normal font-['Pretendard'] leading-5 text-[#D15445]">
                            *결제 유효 기한: {formatDateTime(expiryDate) || '-'}까지
                        </span>

                    </div>
                </Dialog.Body>

                <Dialog.Footer className="flex gap-3 items-center justify-end">
                    <Button
                        styleType="basic"
                        styleSize="M-40"
                        onClick={onClose}
                    >
                        닫기
                    </Button>
                </Dialog.Footer>
            </Dialog.Content>
        </Dialog>
    );
}

